import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const resubmitByApprover = createApi(`ResubmitSlice`,"POST");

const ResubmitSlice = createSlice({
  name: 'ResubmitSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(resubmitByApprover.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(resubmitByApprover.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(resubmitByApprover.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default ResubmitSlice.reducer;